import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/globals.css'
import { CacheProvider } from './app/providers/CacheProvider'
import { AuthProvider } from './app/providers/AuthProvider'
import { MaintenanceProvider } from './app/providers/MaintenanceProvider'
import { ToastProvider } from './app/providers/ToastProvider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { isMaintenanceError } from './services/apiClientErrors'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

// Initialize a single QueryClient instance for the app
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => !isMaintenanceError(error) && failureCount < 3,
    },
  },
})

// Nascondi il loader iniziale quando React è pronto
// Timeout ridotto per transizione più veloce
setTimeout(() => {
  document.documentElement.classList.add('loaded');
  // Rimuovi completamente il loader dopo la transizione
  setTimeout(() => {
    const loader = document.getElementById('initial-loader');
    if (loader) {
      loader.remove();
    }
  }, 300);
}, 50);

createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MaintenanceProvider>
          <CacheProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </CacheProvider>
        </MaintenanceProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)